<div class="facilities">
    <div class="facilities__header">
        <h1 class="facilities__title">Choose Roadmap</h1>

        <div class="facilities__header-right">
            <grainger-logout-button class="floating-button" (clicked)="onLogoutClicked()">
            </grainger-logout-button>
            <img src="assets/images/logo.png" alt="Grainger Logo" class="facilities__logo" />
        </div>
    </div>
    @if (facilities$ | async; as facilities) {
    <ul class="facilities__list">
        @for (facility of facilities; track facility.id) {
        <li class="facility" id="facility-{{ facility.id }}" [routerLink]="['/roadmap', facility.urlSlug]"
            [ngClass]="{ disabled: facility.status !== FacilityStatus.Active }">
            <div class="facility__dollhouse" [graingerBackgroundImage]="facility.dollhouseImage?.thumbnailUrl"></div>
            <h4 class="facility__name">
                {{ facility.name }}
            </h4>
        </li>
        }
    </ul>
    }

    <div class="facilities__footer" *ngIf="(isOnlyBusinessPartner$ | async) === false">
        <h2 class="facilities__footer-heading">Additional Resources</h2>
        <div class="facilities__footer-links">
            <grainger-icon-list-item *ngFor="let link of footerLinks" class="footer-link-button"
                (clicked)="trackClick(link.clickEvent)" [link]="{ name: link.name, url: link.url }"
                [disableEdit]="true"></grainger-icon-list-item>
        </div>

        <!-- NEW CONFIDENTIALITY NOTICE -->
        <div class="facilities__confidentiality">
            <h3>CONFIDENTIALITY NOTICE:</h3>
            <p>
                Information presented within this portal is Confidential and Proprietary and subject to terms and
                conditions within your Master Reseller Agreement with Grainger.<br />

                Specifically, at Section 9. GENERAL TERMS, Subsection a. Confidentiality and Non-Disclosure, “The terms
                of this Agreement, the SOWS, and all exhibits thereto, as well as any information (in any form, means or
                media), including but not limited to plans, pricing, supplier lists, customer lists, analyses,
                projections and opinions, and all such data and knowledge, information and material acquired or
                developed by a Party, Buyer or Seller or an affiliate thereof shall be deemed confidential (hereinafter,
                “Confidential Information”). Confidential Information that is disclosed by a Party (collectively,
                “Disclosing Party”) to the other side (collectively, “Receiving Party”) shall only be used pursuant to
                the terms of this Agreement and the SOWS, and shall not be disclosed by the Receiving Party without
                prior written consent from the Disclosing Party.”<br />

                Should questions exist, please contact
                <a href="mailto:Matt.Kurz@grainger.com">Matt.Kurz&#64;grainger.com</a>
            </p>
        </div>
    </div>
</div>